import { QueryClientProvider } from "@circle-react/providers/QueryClient";

import { PunditUserContextProvider } from "@/react/contexts/punditUserContext";

import type { ErrorTemplateProps } from "./ErrorTemplateComponent";
import { ErrorTemplateComponent } from "./ErrorTemplateComponent";

export const ErrorTemplate = (props: ErrorTemplateProps) => (
  <QueryClientProvider>
    <PunditUserContextProvider>
      <ErrorTemplateComponent {...props} />
    </PunditUserContextProvider>
  </QueryClientProvider>
);
